module.exports = __webpack_public_path__ + "static/ogimage-3ee1ef2fee92acc3ef3e209b1c06105a.png";